import { serverTimestamp } from "firebase/firestore";
import { cashierShiftDefaults } from "./cashierShiftDefaults";

export const cashierShiftConverter = {
    toFirestore(shift) {
        const payload = { ...shift };
        
        // Remove 'id' since it's the document key
        if (payload.id) delete payload.id;
        
        payload.updatedAt = serverTimestamp();
        if (!payload.createdAt) {
            payload.createdAt = serverTimestamp();
        }

        return payload;
    },
    
    fromFirestore(snapshot, options) {
        const data = snapshot.data(options);
        
        // Convert timestamps to date strings or objects if needed,
        // or just pass the raw Firestore Timestamp back to the frontend.
        // We typically handle Date conversion in the component.

        return {
            id: snapshot.id,
            ...cashierShiftDefaults,
            ...data,
        };
    }
};
